import { zodForgivingSchema } from '../../zod/forgivingSchema';
import { CustomerSessionTracking, SessionImageClassFilter, SessionMetricsFilter } from '../session/customerSessionTracking';
import { SnapshotStatsFilter } from '../session/snapshotStats';
import { AnnotationClassName } from '../snapshot/classificationClass';
import { DsiAdditionalClassificationsReview } from './dsiAdditionalClassifications';
import { DsiLabellingDraft } from './dsiLabelling';
import { DsiSessionStatus } from './dsiSession';
import z from 'zod';

export const DsiPaymentStatus = z.enum(['paid', 'notPaid']);
export type DsiPaymentStatus = z.infer<typeof DsiPaymentStatus>;

export interface DsiSessionsFilter {
    sessionGuid?: string;
    storeGuid?: string[];
    customerGuid?: string;
    sessionStatus?: DsiSessionStatus[];
    startDate?: Date | null;
    endDate?: Date | null;
    cartId?: string;
    snapshots?: SnapshotStatsFilter;
    metrics?: SessionMetricsFilter;
    imageClassDetectionProbabilities?: SessionImageClassFilter;
    imageClassBasketCounts?: SessionImageClassFilter;
    paymentMethod?: string[];
    paymentStatus?: DsiPaymentStatus[];
    labelCount?: number | [number | null, number | null];
    bottleBundleChecks?: number | [number | null, number | null];
    expectedWeight?: number | [number | null, number | null];
    actualWeight?: number | [number | null, number | null];
    weightDeviation?: number | [number | null, number | null];
    sort?: Record<string, number>;
    isDemoModeOn?: boolean | null;
    isFullyAnnotated?: boolean | null | undefined;
    hasManualAnnotations?: boolean | null | undefined;
    limit?: number;
}

export const DsiSessionsResponse = zodForgivingSchema(
    z.object({
        sessions: CustomerSessionTracking.array(),
        hasMore: z.boolean(),
    }),
);
export type DsiSessionsResponse = z.infer<typeof DsiSessionsResponse>;

export const DsiSuspiciousSessionsFilter = zodForgivingSchema(
    z.object({
        storeGuid: z.string().array(),
        startDate: z.coerce.date(),
        endDate: z.coerce.date(),
        classificationClassName: AnnotationClassName,
        probabilityThreshold: z.number(),
        limit: z.int().optional(),
    }),
);
export type DsiSuspiciousSessionsFilter = z.infer<typeof DsiSuspiciousSessionsFilter>;

export const DsiFinishSessionDto = z.object({
    status: DsiSessionStatus,
    statusDetails: z.string().array(),
    comment: z.string(),
});
export type DsiFinishSessionDto = z.infer<typeof DsiFinishSessionDto>;

export const DsiAdditionalModelReview = z.object({
    dsiLabelling: DsiLabellingDraft,
    review: DsiAdditionalClassificationsReview,
});
export type DsiAdditionalModelReview = z.infer<typeof DsiAdditionalModelReview>;
